















































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { chargeConfig, chargeModify, rechargePage } from '@/server/api/CanteenManagement'
import DateUtil from '@/utils/toolsForDate'
@Component({
  name: 'MiniProgramChargeSetting'
})
export default class MiniProgramChargeSetting extends Vue {
  public tableData: Array<any> = []
  public dialogVisible = false
  public form: any = {
    displayName: '',
    discountHint: '',
    amount: 0,
    days: 0,
    showOldAmount: false,
    oldAmount: 0
  }
  public rules = {
    displayName: [
      { required: true, message: '请输入展示标题', trigger: 'blur' }
    ],
    discountHint: [
      { required: false, message: '请输入折扣说明', trigger: 'blur' }
    ],
    amount: [
      { required: true, message: '请输入金额（元）', trigger: 'blur' }
    ],
    days: [
      { required: true, message: '请输入生效天数（天）', trigger: 'blur' }
    ],
    showOldAmount: [
      { required: false, message: '请选择是否展示原价', trigger: 'blur' }
    ],
    oldAmount: [
      { required: false, message: '请输入原价（元））', trigger: 'blur' }
    ]
  }
  public theEditObj: any = null
  public theEditindex: any = null
  // public searchKeywords = ''
  public searchDateTime = []
  public userTableData: Array<any> = []
  public payRecordDialogVisible = false
  public payRecordTableData: Array<any> = [
    {
      payDate: '2024-06-22 09:00:00',
      payMoney: 10
    },
    {
      payDate: '2024-06-22 09:00:00',
      payMoney: 10
    },
    {
      payDate: '2024-06-22 09:00:00',
      payMoney: 10
    }
  ]
  public currentPage = 1
  public pageSize = 10
  public total = 0
  public loading = false

  get type () {
    const res = this.$route.query.type
    return res
  }

  get today () {
    return DateUtil.getNowDay()
  }
 
  handleAdd () {
    this.dialogVisible = true
  }

  resetForm (formName: string) {
    (this as any).$refs[formName].resetFields()
  }

  handleCreateSubmit (formName: string) {
    (this as any).$refs[formName].validate(valid => {
      if (valid) {
        const { displayName, discountHint, amount, days, showOldAmount, oldAmount } = this.form
        const newDataList = JSON.parse(JSON.stringify(this.tableData))
        if (this.theEditObj) {
          newDataList.splice(this.theEditindex, 1, {
            displayName,
            discountHint,
            amount,
            days,
            showOldAmount,
            oldAmount
          })
        } else {
          newDataList.push({
            displayName,
            discountHint,
            amount,
            days,
            showOldAmount,
            oldAmount
          })
        }
        this.chargeModifyFun(newDataList, () => {
          this.handleClose()
        })
      } else {
        return false
      }
    })
  }

  handleCancelSubmit () {
    this.resetForm('form')
    this.dialogVisible = false
    this.theEditObj = null
    this.theEditindex = null
  }

  handleClose() {
    this.resetForm('form')
    this.dialogVisible = false
    this.theEditObj = null
    this.theEditindex = null
  }

  handleDelete (index) {
    this.$confirm('确定删除此项吗？', '提示', {
      confirmButtonText: `确定`,
      cancelButtonText: `取消`,
      type: 'warning'
    }).then(() => {
      const newDataList = JSON.parse(JSON.stringify(this.tableData))
      newDataList.splice(index, 1)
      this.chargeModifyFun(newDataList)
    }).catch(() => {})
  }

  handleSearch () {
    this.handleCurrentChange(1)
  }

  handlePayRecord (row) {
    this.payRecordDialogVisible = true
  }

  payRecordHandleClose () {
    this.payRecordDialogVisible = false
  }

  async chargeConfigFun () {
    this.loading = true
    const { data: response } = await chargeConfig()
    this.loading = false
    if (response.code !== 200) return this.$message.error(response.msg)
    this.tableData = response.data || []
  }

  async chargeModifyFun (params, cd?: () => void) {
    const { data: response } = await chargeModify(params)
    if (response.code !== 200) return this.$message.error(response.msg)
    this.$message.success('操作成功')
    this.chargeConfigFun()
    cd && cd()
  }

  async rechargePageFun (messageFlag: boolean) {
    if (!this.searchDateTime.length) {
      messageFlag && this.$message.error('请选择日期时间')
      return false
    }
    const [start, end] = this.searchDateTime
    const params = {
      pageNo: this.currentPage,
      pageSize: this.pageSize,
      start: start + ' ' + '00:00:00',
      end: end + ' ' + '23:59:59'
    }
    this.loading = true
    const { data: response } = await rechargePage(params)
    this.loading = false
    if (response.code !== 200) {
      messageFlag && this.$message.error(response.msg)
      return false
    }
    this.userTableData = (response.data.records || []).map(item => {
      item.payDate = item.createdTime
      item.payMoney = item.rechargeAmount / 100
      return item
    })
    this.total = response.data.total || 0
  }

  handleSizeChange (pageSize: number) {
    this.pageSize = pageSize
    this.rechargePageFun(true)
  }

  handleCurrentChange (currentPage: number) {
    this.currentPage = currentPage
    this.rechargePageFun(true)
  }

  handleShowOldAmountChange (e) {
    if (!e) {
      this.form.oldAmount = 0
    }
  }

  handleToTopOne (index) {
    this.$confirm('确定上移此项吗？', '提示', {
      confirmButtonText: `确定`,
      cancelButtonText: `取消`,
      type: 'warning'
    }).then(() => {
      const newDataList = JSON.parse(JSON.stringify(this.tableData))
      ;[newDataList[index], newDataList[index - 1]] = [newDataList[index - 1], newDataList[index]]
      this.chargeModifyFun(newDataList)
    }).catch(() => {})
  }

  handleToBottomOne (index) {
    this.$confirm('确定下移此项吗？', '提示', {
      confirmButtonText: `确定`,
      cancelButtonText: `取消`,
      type: 'warning'
    }).then(() => {
      const newDataList = JSON.parse(JSON.stringify(this.tableData))
      ;[newDataList[index], newDataList[index + 1]] = [newDataList[index + 1], newDataList[index]]
      this.chargeModifyFun(newDataList)
    }).catch(() => {})
  }

  handleEdit (index) {
    const item = this.tableData[index]
    this.theEditObj = item
    this.theEditindex = index
    this.form.displayName = item.displayName || ''
    this.form.discountHint = item.discountHint || ''
    this.form.amount = item.amount || 0
    this.form.days = item.days || 0
    this.form.showOldAmount = item.showOldAmount || false,
    this.form.oldAmount = item.oldAmount || 0
    this.dialogVisible = true
  }

  mounted () {
    if (this.type === 'setting') {
      this.chargeConfigFun()
    } else if (this.type === 'record') {
      this.searchDateTime = [DateUtil.getStartDayOfMonth(), this.today]
      this.rechargePageFun(false)
    }
  }
}
